<div class="input-form" [ngClass]="customClass">
  @if (label) {
  <label class="label">{{ label | translate }}</label>
  }
  <ion-item
    lines="none"
    class="input-item"
    [ngClass]="{
      'has-error': control.invalid && control.touched,
      'show-border': showBorder
    }"
    [class]="customClass"
  >
    @if (iconName) {
    <ion-icon [name]="iconName" slot="start" class="input-icon" />
    }
    <ion-input
      [type]="type"
      [formControl]="formControl"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
      [disabled]="disabled"
      [readonly]="readonly"
      [clearInput]="clearInput"
      [autocomplete]="autocomplete"
      class="input"
    />
  </ion-item>

  @if (errorMessage) {
  <div class="error-message">
    {{ errorMessage }}
  </div>
  }
</div>
